module.exports = __webpack_public_path__ + "img/reward8.21387c5a.png";